import React from 'react'
import MuiSvgIcon from '@material-ui/core/SvgIcon';

export default function FlipDirection(props:any) {
    return (
        <svg  width="96" height="90" viewBox="0 0 96 90" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M32.5 59.7929V1.20711L61.5 30.2071V88.7929L32.5 59.7929Z" fill="#888888" stroke="#888888"/>
        <path d="M19 43.5454C18.4477 43.5454 18 43.9931 18 44.5454C18 45.0977 18.4477 45.5454 19 45.5454V43.5454ZM40 43.5454H19V45.5454H40V43.5454Z" fill="#E7EFF8"/>
        <path d="M25.5455 38L19 44.5455L25.5455 51.0909" stroke="#E7EFF8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <g opacity="0.5">
        <path d="M78 45.4546C78.5523 45.4546 79 45.0069 79 44.4546C79 43.9023 78.5523 43.4546 78 43.4546V45.4546ZM62 45.4546H78V43.4546H62V45.4546Z" fill="#888888"/>
        <path d="M71.4545 51L78 44.4545L71.4545 37.9091" stroke="#888888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        </svg>
      );
}